import * as UI from "@iyk/ui"
import { Data } from "effect"

const make = Data.case<Config>()

export const config = make({
  appId: "bubblelab",
  general: {
    email: "bubblelab@iyk.app",
    name: "Bubblelab",
    baseUrl: "https://bubblelab.iyk.app",
  },
  meta: {
    description: "Bubblelab",
  },
  social: [
    {
      label: "Instagram",
      logo: UI.Icon.Instagram,
      href: "https://www.instagram.com/bubblelab_official/",
    },
    {
      label: "Website",
      logo: UI.Icon.Globe,
      href: "http://bubblelab.kr",
    },
  ],
})

interface Config {
  appId: string
  general: {
    email: string
    name: string
    baseUrl: string
  }
  meta: {
    description: string
  }
  social: Array<{
    label: string
    logo: React.ElementType
    href: string
  }>
}
